var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    "+_vm._s(Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(_vm.price))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Purchases/Freight/FreightPrice.vue